import { produce } from 'immer';

import * as Types from './types';
import { actionTypes } from './constants';

export const defaultState: Types.ICasinoComponentState = {
    isIntegrationScriptLoaded: false
};

export const reducer = produce((draftState, action: Types.TCasinoComponentAction): Types.ICasinoComponentState | void => {
        switch (action.type) {
            case actionTypes.CASINO_COMPONENT_INTEGRATION_SCRIPT_LOADED_TOGGLE: {
                draftState.isIntegrationScriptLoaded = action.payload;

                break;
            }

            default: {
                break;
            }
        }
    }, defaultState);
